<template>
  <a-config-provider 
    :theme ="{
       token:{
          colorPrimary:'#1061fe',
          borderRadius: 8
        },
        components: {
          Checkbox: {
            colorPrimary: '#0f172a',
            colorPrimaryBorder: '#42474f',
            colorPrimaryHover : '#1c2436',
          },
          Switch :{
            colorPrimary: '#0f172a',
            colorPrimaryBorder: '#42474f',
            colorPrimaryHover : '#1c2436',
          },
          Button : {
            colorPrimary: '#0f172a',
            colorPrimaryBorder: '#42474f',
            colorPrimaryHover : '#1c2436',
          },
          Radio : {
            colorPrimary: '#0f172a',
            colorPrimaryBorder: '#42474f',
            colorPrimaryHover : '#1c2436',
          }
        },
      }">
  <router-view/>
  </a-config-provider>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body{
  margin: 0px;
}
.ant-btn-primary {
  //background-color: #000000;
}
.ant-btn-primary:not(:disabled):hover {
  //background-color: #000000;
}
.ant-tag {
  border-color: #00000000
}

</style>
